module.exports = __webpack_public_path__ + "img/slack.75fafc0c.svg";